<template>
  <div class="page-wrapper">
    <router-view :hasHeaderNav="hasHeaderNav" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * PCページ 共通調整用Wrapper
 */
export default defineComponent({
  name: 'PageWrapper',
  setup() {
    const hasHeaderNav = computed(
      () =>
        !(DeviceInfo.isMobile() && (DeviceInfo.isAndroidBrowser() || DeviceInfo.isiOSBrowser())),
    )
    return {
      hasHeaderNav,
    }
  },
})
</script>

<style lang="scss">
.page-wrapper {
  .atom-link-btn,
  .atom-router-btn,
  .atom-input-btn {
    max-width: 345px;
    margin: 0 auto;
  }

  .action-buttons-section {
    .atom-link-btn,
    .atom-router-btn,
    .atom-input-btn {
      margin: 0;
    }
  }

  .login-pane {
    max-width: 377px;
  }

  .header-pane {
    &--has-nav {
      @media screen and (max-width: $responsiveTabletWidth - 1px) {
        padding: 0 min(#{convertPXtoVW(14)}, 14px);

        .header-pane {
          &__logo {
            width: min(#{convertPXtoVW(204)}, 204px);
          }
        }
      }
    }
  }

  .mypage-wrapper,
  .account-settings-wrapper,
  .registration-form-page,
  .password-reset-page {
    max-height: 100vh;
    overflow-y: auto;

    .header-pane {
      position: sticky;
      top: 0;
    }

    .sub-header-section {
      position: sticky;
      top: $headerPaneHeight;

      .atom-link-btn,
      .atom-router-btn,
      .atom-input-btn {
        max-width: none;
        margin: 0;
      }
    }

    .footer {
      display: none;
    }

    .action-buttons-section {
      bottom: 0;

      &__inner {
        @media screen and (min-width: $responsiveTabletWidth) {
          flex-direction: row-reverse;
        }
      }
    }
  }
}
</style>
